import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Helmet } from "react-helmet";
import axios from "../../axios/index";

// context
import { UserContext } from "../Context/UserContextProvider";

// styles
import styles from "./Home.module.css";
import Dstyles from "../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "./HomeNavbar/HomeNavbar";
import HomeModal from "./HomeModal/HomeModal";
import Banner from "./Banner/Banner";
import CardsSlider from "./CardsSlider/CardsSlider";
import AddEstateBanner from "./AddEstateBanner/AddEstateBanner";
import Blogs from "./Blogs/Blogs";
import ContactUs from "./ContactUs/ContactUs";
import Footer from "./Footer/Footer";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LandingBanner from "./LandingBanner/LandingBanner";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const Home = () => {
  const { userToken, resetState } = useContext(UserContext);
  const { state } = useLocation();
  const navigate = useHistory();
  const { deal } = useParams();
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState({ salesData: [], rentSalesData: [], blogsData: [], bannerDataOne: [], bannerDataTwo: [], phoneData: [] });

  let [dealType, setDealType] = useState(0);
  let dealTypeRef = useRef();

  useEffect(() => {
    switch (deal) {
      case "خرید":
      default:
        setDealType(0);
        break;
      case "رهن-و-اجاره":
        setDealType(1);
        break;
      case "پیش-فروش":
        setDealType(2);
        break;
      case "مشارکت":
        setDealType(3);
        break;
    }
  }, [deal]);

  useEffect(() => {
    if ("redirect" in (state || {})) {
      navigate.push(state?.redirect, { ...state?.redirectData });
    }
  }, []);

  const fetchData = useCallback(async () => {
    try {
      //const salesDataResponse = await axios.get("Home/GetProducts?EstateType=2&Status=2&EstateRegion=1&Take=10&dealType=" + dealType || 0);
      //const rentSalesDataResponse = await axios.get("Home/GetProducts?EstateType=1&Status=2&EstateRegion=1&Take=10");
      const blogsDataResponse = await axios.get("Home/GetArticles");
      const bannerFirst = await axios.get("Banner/GetBannerByPosition?position=0");
      const bannerSecond = await axios.get("Banner/GetBannerByPosition?position=1");
      const phone = await axios.get("SiteSetting");
      setData(prev => {
        return {
          ...prev,
          blogsData: blogsDataResponse.data.data.data,
          bannerDataOne: bannerFirst.data.data,
          bannerDataTwo: bannerSecond.data.data,
          phoneData: phone.data.data,
        };
      });

      const seoData = phone.data.data.mainPageSeoData;
      if (state && state.success) {
        notify(state.message, "success");
      }
    } catch (error) {
      console.error(error);
    }

    return () => {};
  }, [state]);

  useEffect(() => {
    fetchData();
  }, [fetchData, userToken, state]);

  useEffect(() => {
    dealTypeRef.current = dealType;
    axios.get("Home/GetProducts?EstateType=2&Status=2&EstateRegion=1&Take=10&dealType=" + dealType || 0).then(res => {
      // console.log(dealTypeRef.current);
      // console.log(res.data.data.filterParams.dealType);
      if (res.data.data.filterParams.dealType != dealTypeRef.current) {
        return;
      }
      setData(prev => {
        return { ...prev, salesData: res.data.data.data };
      });
    });
  }, [dealType]);

  return (
    <>
      <HomeModal show={modalShow} onHide={() => setModalShow(false)} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <div className="d-flex justify-content-center align-items-start vw-100">
        <div className={`${styles.container} w-100 ms-0 p-0`}>
          <HomeNavbar showModal={() => setModalShow(true)} />
          {/*<Banner />*/}
          <LandingBanner dealType={dealType} />
          <CardsSlider dealType={dealType} cardData={data.salesData} rentsCard={[]} showModal={() => setModalShow(true)} />
          <AddEstateBanner bannerDataOne={data.bannerDataOne} />
          {data.blogsData.length > 0 ? (
            <section className="py-3" style={{ background: "#F9F9F9" }}>
              <Blogs blogsData={data.blogsData} />
            </section>
          ) : (
            <></>
          )}

          <section className="py-3" style={{ background: "#FFFFFF" }}>
            <ContactUs bannerDataTwo={data.bannerDataTwo} phoneData={data.phoneData} />
          </section>
          <Footer />
        </div>
      </div>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // postHandler()
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // setBtnLoader(false)
    }
  }
};

export default React.memo(Home);
